export default function updateTaxes(api: GlobalFetch) {
  return async function() {
    const requestBody = {
      return_url: window.location.origin + '/price/method',
      refresh_url: window.location.origin + '/price/method',
    }

    const buildUrl = `/api/v2/stripe/create`
    const response = await api.fetch(buildUrl, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })
    const responseBody: IData = await response.json()

    return responseBody.items
  }
}

export interface IData {
  messages: string[]
  items: IItemData
}

interface IItemData {
  url: string
}
